import React, { useState , useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import StreetView from './StreetView.js';
import { Config } from '../../../Utils/Config.js';

const ParentStreetView = (modalValue  , trackModal , storeName , latLong) => {  
  const [modal , setModal] = useState(false);

  useEffect(()=>{
    setModal(modalValue);
  }, [modalValue])

  const streetViewPanoramaOptions = {
    position: { lat: +latLong.lat, lng: +latLong.long },
    pov: { heading: 100, pitch: 0 },
    zoom: 1
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={trackModal} className="store-mainpopup">
        <ModalHeader toggle={trackModal}>
          {storeName} <br />
          <i className="op-min">This is the street view from Google Maps.</i>
        </ModalHeader>
        <ModalBody>
          <StreetView
            apiKey={Config.googleMapsApiKey}
            streetViewPanoramaOptions={streetViewPanoramaOptions}
            onPositionChanged={position => console.log("position changed", position)}
            onPovChanged={pov => console.log("pov changed", pov)}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ParentStreetView;
